import React from 'react';
import S3Upload from '../S3Upload';

/* ══════════════════════════════════════
   THE ROUND'S CAR (owner, 1 Nov) — optional: a car name and a photo,
   shown on the round's card in the app and on the website. Saved on the
   event as carName / carImage; leave blank for rounds with a free choice.
   ══════════════════════════════════════ */
export default function CarField({ name, image, onName, onImage, uploadKey }) {
  return (
    <div className="form-row" style={{ alignItems: 'flex-start' }}>
      <div className="form-group" style={{ flex: 1 }}>
        <label className="form-label">Car (optional)</label>
        <input className="form-input" value={name || ''} maxLength={120}
          placeholder="e.g. Porsche 911 RSR (991) '17"
          onChange={e => onName(e.target.value)} />
        <span style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4, display: 'block' }}>
          Leave blank if drivers choose their own car.
        </span>
      </div>
      <div className="form-group" style={{ width: 200 }}>
        <label className="form-label">Car photo</label>
        <S3Upload
          key={uploadKey}
          folder="championships/events/cars"
          accept="image/*"
          label={image ? 'Replace photo' : 'Upload photo'}
          currentUrl={image || ''}
          onUploaded={({ publicUrl }) => onImage(publicUrl)}
        />
        {image && (
          <button type="button" className="btn btn-secondary btn-sm" style={{ marginTop: 6 }}
            onClick={() => onImage('')}>Remove photo</button>
        )}
      </div>
    </div>
  );
}
